export * from "-!../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./globalcontact.vue?vue&type=template&id=718dbdf8"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/globalcontact.vue?vue&type=template&id=718dbdf8
// module id = 36
// module chunks = 0